import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import { Switch, FormControlLabel } from '@mui/material';

// interface
import { BasicDetailsTypes } from "../../../data/settings";
import { Const } from "const";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { ucChatAlighRight } from "../../../redux/profile2/p2_reducer";
import { changelayoutMode } from "../../../redux/actions";
import { LAYOUT_MODES } from "../../../../src/constants";
import { UserTypes } from "api";
import { Utils } from "helpers/utils";
import { setShareFilterWpTask } from "../../../redux/workplace/wpActions";

interface DisplaySettingProps {
  basicDetails: BasicDetailsTypes;
}
const DisplaySetting = ({ basicDetails }: DisplaySettingProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Layout,
    (state) => state.Profile2,
    (layout, p2) => ({
      layoutMode: layout.layoutMode,
      chatAlighRight: p2.chatAlighRight,
      userType: p2.userType,
    })
  );
  const { chatAlighRight, layoutMode, userType } = useAppSelector(storeData);

  // console.log('layoutMode = ' + layoutMode);
  const classNames = [
    'body-font-default',
    'body-font-step10',
    'body-font-step11',
    'body-font-step12',
    'body-font-step13',
    'body-font-step14',
  ];

  const [classIndex, setClassIndex] = useState<number>(() => {
    const storedClass = localStorage.getItem("bodyFontClass");
    const index = classNames.indexOf(storedClass ?? '');
    return index !== -1 ? index : 0; // Default to 0 if not found
  });

  const [wpShowLastChat, setWpShowLastChat] = useState<boolean>(Utils.Conf_WorkPlaceTitleShowLastChat());
  const [wpMemFilter, setWpMemfilter] = useState<boolean>(Utils.Conf_WorkPlaceRememberFilter());
  const [wpShareFilter, setWpShareFilter] = useState<boolean>(Utils.Conf_ShareFilterWpTask());
  const wpShowLastChatToggle = () => {
    const val = !wpShowLastChat;
    Utils.Conf_WorkPlaceTitleShowLastChat(val);
    setWpShowLastChat(val);
  }

  const wpMemFilterToggle = () => {
    const val = !wpMemFilter;
    Utils.Conf_WorkPlaceRememberFilter(val);
    setWpMemfilter(val);
  }

  const wpShareFilterToggle = () => {
    const val = !wpShareFilter;
    Utils.Conf_ShareFilterWpTask(val);
    setWpShareFilter(val);
    dispatch(setShareFilterWpTask(val));
  }


  const fnAdjustClass = (step: number) => {
    try {
      setClassIndex((prevIndex) => {
        const newIndex = prevIndex + step;
        // Ensure the index stays within bounds
        return Math.max(0, Math.min(newIndex, classNames.length - 1));
      });
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }

  useEffect(() => {
    const bodyFontClass = classNames[classIndex];
    document.body.className = bodyFontClass;
    localStorage.setItem("bodyFontClass", bodyFontClass); // Save the current class to localStorage
  }, [classIndex, classNames]);

  //console.log('chatAlighRight:', chatAlighRight);

  const onChatAlignChange = async (value: any) => {
    try {
      dispatch(ucChatAlighRight(value));
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }

  return (
    <div className="accordion-body " style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <div>
        <p className="text-primary mb-1">โหมดการแสดงผล</p>
        <div className="d-flex justify-content-between align-items-center">
          <FormControlLabel
            control={
              <Switch checked={layoutMode === LAYOUT_MODES.LIGHT}
                color={layoutMode === LAYOUT_MODES.LIGHT ? "primary" : "secondary"}
                onChange={(e) => { dispatch(changelayoutMode(layoutMode === LAYOUT_MODES.LIGHT ? LAYOUT_MODES.DARK : LAYOUT_MODES.LIGHT)) }}
              />}
            label={layoutMode === LAYOUT_MODES.LIGHT ? "โหมดสว่าง" : "โหมดมืด"} />
        </div>


        {userType === UserTypes.Employee && (<>
          <p className="text-primary mb-1">ข้อความล่าสุดในหัวข้อ WP</p>
          <div className="d-flex justify-content-between align-items-center">
            <FormControlLabel
              control={
                <Switch checked={wpShowLastChat}
                  color={wpShowLastChat ? "primary" : "secondary"}
                  onChange={(e) => { wpShowLastChatToggle() }}
                />}
              label={wpShowLastChat ? "แสดง" : "ไม่แสดง"} />
          </div>

          <p className="text-primary mb-1">จำ filter unread ใน WP</p>
          <div className="d-flex justify-content-between align-items-center">
            <FormControlLabel
              control={
                <Switch checked={wpMemFilter}
                  color={wpMemFilter ? "primary" : "secondary"}
                  onChange={(e) => { wpMemFilterToggle() }}
                />}
              label={wpMemFilter ? "จำ" : "ไม่จำ"} />
          </div>

          <p className="text-primary mb-1">ใช้ filter เดียวกันใน WP/Task</p>
          <div className="d-flex justify-content-between align-items-center">
            <FormControlLabel
              control={
                <Switch checked={wpShareFilter}
                  color={wpShareFilter ? "primary" : "secondary"}
                  onChange={(e) => { wpShareFilterToggle() }}
                />}
              label={wpShareFilter ? "ใช้ร่วมกัน" : "แยกกัน"} />
          </div>

        </>
        )}

      </div>


      <div >
        <p className="text-primary mb-1">ขนาดตัวอักษร</p>

        <div className="d-flex justify-content-between align-items-center">
          <div onClick={() => fnAdjustClass(-1)} style={{ fontSize: "1.3em" }}><i className='bx bxs-minus-circle text-warning'></i></div>
          <div className={"text-center flex-grow-1 " + classNames[classIndex]}>ข้อความ/text</div>
          <div onClick={() => fnAdjustClass(+1)} style={{ fontSize: "1.3em" }}><i className='bx bxs-plus-circle text-success' ></i></div>
        </div>
        {/* <h5 className="font-size-14">{fullName}</h5> */}
      </div>

      <div >
        <p className="text-primary mb-1">ข้อความแชทด้านขวา</p>
        <div className="d-flex justify-content-between align-items-center row">
          <div className="col">
            <select className="form-control" style={{ fontSize: "1.0em", padding: "4px" }} value={chatAlighRight} onChange={(e) => onChatAlignChange(e.target.value)}>
              {/* <option value={Const.UC_CHAT_ALIGH_RIGHT_COMP} selected={chatAlighRight == Const.UC_CHAT_ALIGH_RIGHT_COMP}> 🔸 ตามบริษัท</option>
              <option value={Const.UC_CHAT_ALIGH_RIGHT_ME} selected={chatAlighRight == Const.UC_CHAT_ALIGH_RIGHT_ME}> 🔸 เฉพาะฉัน</option> */}
              <option value={Const.UC_CHAT_ALIGH_RIGHT_COMP} > 🔸 ตามบริษัท</option>
              <option value={Const.UC_CHAT_ALIGH_RIGHT_ME} > 🔸 เฉพาะฉัน</option>

            </select>
          </div>
        </div>
      </div>


      {/* <hr/>
      Image
      <input type="file" accept="image/*"/>
      <br/>
      Camera
      <input type="file" accept="image/*" capture="environment" />
      <br/>
      File
      <input type="file" />  */}

    </div>
  );
};

export default DisplaySetting;
